import React from 'react';
import MainLayout from '../components/Layout/MainLayout.js';

const IncludedInPrice = () => (
    <MainLayout>
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl sm:text-3xl font-bold font-montserrat text-gray-900 mb-6">
                Hvad får du med i prisen?
            </h1>
            <ul className="list-disc pl-6 space-y-4 text-gray-700 text-lg">
                <li>Professionel, mobilvenlig hjemmeside med dit eget domæne eller subdomæne</li>
                <li>AI-genereret indhold tilpasset din virksomhed</li>
                <li>Ubegrænset antal sider og billedgalleri <span className="text-sm">(ikke ubegrænset)</span></li>
                <li>Brugervenligt kontrolpanel til nem redigering</li>
                <li>Hosting, backup og sikkerhed inkluderet</li>
                <li>Gratis support og løbende opdateringer</li>
                <li>SEO-optimering og mulighed for Google Analytics</li>
            </ul>
            <p className="mt-8 text-gray-600">
                Du får alt, hvad du behøver for at komme professionelt online – ingen skjulte gebyrer eller binding. Start din gratis prøve på <a href="/onboarding" className="text-brand-dark underline">onboarding</a>, eller læs mere om <a href="/funktioner" className="text-brand-dark underline">funktionerne</a> og få tips i vores <a href="/blog" className="text-brand-dark underline">blog</a>.
            </p>
        </div>
    </MainLayout>
);

export default IncludedInPrice;